import type { ProgramConfig } from './types'
import { TIERS } from './types'

const MONEY = /^\d+(\.\d{1,6})?$/

// Mirrors backend model/partner/config.go Validate().
export const validateConfig = (cfg: ProgramConfig): string[] => {
  const errs: string[] = []
  if (cfg.tiers.length !== 3) errs.push('Exactly three tiers are required')
  const seen = new Set<string>()
  cfg.tiers.forEach((t) => {
    if (!TIERS.includes(t.name)) errs.push(`Unknown tier "${t.name}"`)
    if (seen.has(t.name)) errs.push(`Duplicate tier "${t.name}"`)
    seen.add(t.name)
    if (!Number.isInteger(t.min_active_referrals) || t.min_active_referrals < 0)
      errs.push(
        `Tier ${t.name}: min active referrals must be a non-negative integer`,
      )
    if (
      !Number.isInteger(t.share_bips) ||
      t.share_bips < 0 ||
      t.share_bips > 10000
    )
      errs.push(`Tier ${t.name}: share must be between 0% and 100%`)
    if (!MONEY.test(t.signup_bonus_usdc))
      errs.push(`Tier ${t.name}: sign-up bonus must be a non-negative amount`)
    if (!Number.isInteger(t.campaign_link_limit) || t.campaign_link_limit < 0)
      errs.push(
        `Tier ${t.name}: campaign link limit must be a non-negative integer`,
      )
  })
  if (!MONEY.test(cfg.signup_min_deposit_usdc))
    errs.push('Sign-up minimum deposit must be a non-negative amount')
  if (
    !Number.isInteger(cfg.signup_bonus_hold_days) ||
    cfg.signup_bonus_hold_days < 0
  )
    errs.push('Hold days must be a non-negative integer')
  if (
    !Number.isInteger(cfg.attribution_window_hours) ||
    cfg.attribution_window_hours <= 0
  )
    errs.push('Attribution window must be a positive integer')
  return errs
}
